import React, { useContext, useMemo } from 'react';
import { DwTable, onRowDelete } from '../../../table/DwTable';
import { Config } from '../../../table/config';
import { NavigateFunction, Outlet, generatePath } from 'react-router-dom';
import { CompanyFormContext } from '../CompanyForm';
import { PATH_CP_COMPANY_ACCOUNT, PATH_VARIABLE_COMPANY_ACCOUNT_ID } from '../../../../routerPaths';
import util from '../../../../common/util';
import { RemoveButton } from '../../../table/RemoveButton';
import { AccountModel } from '../../../../model/account';
import accounts from '../../../../api/accounts';
import { AccountField } from '../../account/accountField';

const CompanyAccounts: React.FC = () => {
    const {
        company: { id: companyId },
    } = useContext(CompanyFormContext);
    const config = useMemo(() => {
        return Config.builder<AccountModel>()
            .column((builder) => builder.id().filterable(false))
            .column((builder) => builder.text('Р/Счет', AccountField.NUMBER).sortable(false))
            .column((builder) => builder.text('Банк', AccountField.BANK).sortable(false))
            .column((builder) => builder.text('БИК', AccountField.BIK).sortable(false))
            .column((builder) => builder.text('Корр. счет', AccountField.CORRESPONDENT_NUMBER).sortable(false))
            .column((builder) =>
                builder
                    .getter((model, _, refresh) => (
                        <RemoveButton
                            onClick={() =>
                                onRowDelete(refresh, () => accounts.delete(model.id))
                            }
                        />
                    ))
                    .sortable(false)
                    .filterable(false)
                    .width('45px')
                    .cls('text-center')
            )
            .columnsSelector(false)
            .load((ctx) => accounts.listForCompany(ctx.state.request, companyId))
            .formUrl(
                generatePath(PATH_CP_COMPANY_ACCOUNT, {
                    companyId: util.stringOrEmpty(companyId),
                    [PATH_VARIABLE_COMPANY_ACCOUNT_ID]: '',
                })
            )
            .onClick((id: number, navigate: NavigateFunction) =>
                navigate(
                    generatePath(PATH_CP_COMPANY_ACCOUNT, {
                        companyId: util.stringOrEmpty(companyId),
                        [PATH_VARIABLE_COMPANY_ACCOUNT_ID]: util.stringOrEmpty(id),
                    })
                )
            )
            .id(`company_${companyId}_accounts`)
            .build();
    }, [companyId]);

    return (
        <>
            <div className='accounts d-flex mb-3'>
                <DwTable header='Расчетные счета' config={config} />
            </div>
            <Outlet />
        </>
    );
};

export default CompanyAccounts;
